import script from "./Grid.vue?vue&type=script&setup=true&lang=js"
export * from "./Grid.vue?vue&type=script&setup=true&lang=js"

import "./Grid.vue?vue&type=style&index=0&id=03c4cd50&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03c4cd50"]])

export default __exports__